
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ai-wizard",
      function () {
        return require("private-next-pages/blog/ai-wizard.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/ai-wizard"])
      });
    }
  